import { constantCreator } from '~/utils/constantsCreator';
import ga from 'react-ga';
import fetch from 'isomorphic-fetch';
import config from '~/config';
// import qs from 'qs';
import api from '~/utils/api';
import { path } from '~/utils/media';

const constant = constantCreator('app');
const search = constantCreator('search');

const LOADING = constant('LOADING');
const LOADED = constant('LOADED');
const CUSTOM_THEME = constant('CUSTOM_THEME');
const GET_INITIAL_DATA = constant('GET_INITIAL_DATA', true);
const PRE_FETCH = constant('PRE_FETCH', true);
const SET_IS_MOBILE = constant('SET_IS_MOBILE');
const ADD_UTM = constant('ADD_UTM', true);
// const SET_WHITELABEL = constant('SET_WHITELABEL');

const LOG_SUBMIT_FULL_TEXT_SEARCH = search('LOG_SUBMIT_FULL_TEXT_SEARCH', true);

// const GDPR_BANNER_SHOW = constant('GDPR_BANNER_SHOW');
// const GDPR_BANNER_CLOSE = constant('GDPR_BANNER_CLOSE');

const SHOW_GDPR_CONSENT_BAR = constant('SHOW_GDPR_CONSENT_BAR');
const HIDE_GDPR_CONSENT_BAR = constant('HIDE_GDPR_CONSENT_BAR');

const COUNT_BODY_SCROLL_LOCKING = constant('COUNT_BODY_SCROLL_LOCKING');

const GET_PARTNER_CONFIG = constant('GET_PARTNER_CONFIG', true);

const OPEN_TRIP_PREFERENCE_MODAL = constant('OPEN_TRIP_PREFERENCE_MODAL');
const CLOSE_TRIP_PREFERENCE_MODAL = constant('CLOSE_TRIP_PREFERENCE_MODAL');

const LOG_TRIP_PREFERENCE = constant('LOG_TRIP_PREFERENCE');
const LOG_ON_SEEN_TRIP_PREFERENCE_POPUP = constant('LOG_ON_SEEN_TRIP_PREFERENCE_POPUP');
const LOG_CLOSE_TRIP_PREFERENCE = constant('LOG_CLOSE_TRIP_PREFERENCE');
const LOG_CLOSE_COUNTRY_SELECTOR = constant('LOG_CLOSE_COUNTRY_SELECTOR');

const initialState = {
  isLoading: false,
  isPrefetched: false,
  isMobile: false,
  bodyScrollLockingCount: 0,
  isTripPreferenceModalOpened: false,
  customTheme: {},
  isPartner: !!global.__PARTNER__,
  partnerConfig: {},
  isGDPR: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOADING:
    case LOG_SUBMIT_FULL_TEXT_SEARCH.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case LOADED:
    case LOG_SUBMIT_FULL_TEXT_SEARCH.REJECTED:
      return {
        ...state,
        isLoading: false,
      };
    case PRE_FETCH.PENDING:
      return state;
    case PRE_FETCH.RESOLVED:
      return {
        ...state,
        isPrefetched: true,
      };
    case PRE_FETCH.REJECTED:
      return {
        ...state,
        isPrefetched: true,
      };
    case SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.active,
      };
    case CUSTOM_THEME:
      return {
        ...state,
        customTheme: action.theme,
      };
    case SHOW_GDPR_CONSENT_BAR:
      return {
        ...state,
        isGDPR: true
      };
    case HIDE_GDPR_CONSENT_BAR:
      return {
        ...state,
        isGDPR: false
      };
    case COUNT_BODY_SCROLL_LOCKING: {
      const { isLocked } = action;
      return {
        ...state,
        bodyScrollLockingCount: state.bodyScrollLockingCount + (isLocked ? 1 : -1),
      };
    }
    case GET_PARTNER_CONFIG.RESOLVED: {
      const { found, ...configData } = action.data;
      let logos = {};
      if (found && configData.logos) {
        logos = {
          ...(configData.logos.desktop ? { desktop: path(configData.logos.desktop) } : {}),
          ...(configData.logos.desktop2x ? { desktop2x: path(configData.logos.desktop2x) } : {}),
          ...(configData.logos.mobile ? { mobile: path(configData.logos.mobile) } : {}),
          ...(configData.logos.mobile2x ? { mobile2x: path(configData.logos.mobile2x) } : {}),
          ...(configData.logos.alt ? { alt: configData.logos.alt } : {}),
        };
      }
      return {
        ...state,
        isPartner: found,
        affid: action.affid,
        ...(found ? { partnerConfig: { ...configData, logos, theme: {}, affid: action.affid } } : {})
      };
    }
    case OPEN_TRIP_PREFERENCE_MODAL: {
      return {
        ...state,
        isTripPreferenceModalOpened: true
      };
    }
    case CLOSE_TRIP_PREFERENCE_MODAL: {
      return {
        ...state,
        isTripPreferenceModalOpened: false
      };
    }
    default:
      return state;
  }
};

export const analytics = {
  [LOG_TRIP_PREFERENCE]: action => ({ name: 'Trip Preference', category: 'Trip Preference', data: action.data, providers: 'database' }),
  [LOG_ON_SEEN_TRIP_PREFERENCE_POPUP]: action => ({ name: 'View Trip Preference Popup', category: 'Trip Preference', data: action.data, providers: 'database' }),
  [LOG_CLOSE_COUNTRY_SELECTOR]: () => ({ name: 'Close Country Selector', category: 'Country Selector', providers: 'database' }),
  [LOG_CLOSE_TRIP_PREFERENCE]: (action) => ({ name: 'Close Trip Preference', category: 'Trip Preference', providers: 'database', data: { step: action.step } })
};

export const actions = {
  setShowGDPR: (isOpen) => ({ type: isOpen ? SHOW_GDPR_CONSENT_BAR : HIDE_GDPR_CONSENT_BAR }),
  loading: () => ({ type: LOADING }),
  loaded: () => ({ type: LOADED }),
  setCustomTheme: (theme = '') => ({ type: CUSTOM_THEME, theme }),
  addUtm: ({ utm_source, utm_medium, utm_campaign }) => ({ // eslint-disable-line
    type: ADD_UTM,
    promise: import(/* webpackChunkName: "qs.module" */'qs')
      .then(({ stringify }) => {
        return api.get(`/session/utm?${stringify({ utm_source, utm_medium, utm_campaign })}`);
      }),
  }),
  getInitialData: () => async dispatch => {
    dispatch({ type: GET_INITIAL_DATA.PENDING });
    // const uniqueId = cookie.parse(window.document.cookie).unique_id;
    // const userId = this.props.user ? this.props.user._id : null; // force push
    // const userId = null;
    const { data } = await api.get('/combined/dynamic');
    // ga.initialize(config.gaTokens.en, {
    //   debug: false,
    //   gaOptions: {
    //     clientId: uniqueId,
    //     userId,
    //   },
    // });
    // ga.plugin.require('displayfeatures');
    window.requestIdleCallback(() => {
      // ga.initialize(config.gaTokens.en, {
      //   debug: false,
      //   gaOptions: {
      //     clientId: uniqueId,
      //     userId,
      //   },
      // });
      // ga.plugin.require('displayfeatures');
      if (data.sessionData && data.sessionData.userType && data.sessionData.userType.type) {
        ga.set({dimension1: data.sessionData.userType.type}, ['auTracker']);
      }
      ga.set({
        dimension4: 'true',
        // dimension18: data.userConfigs.hideLightning ? 'true' : 'false',
        dimension18: 'false',
        // dimension20: data.userConfigs.paypalFirst ? 'true' : 'false'
        dimension20: 'false'
      }, ['auTracker']);
      // ga.set({ referrer: config.baseURL.en });
      ga.pageview(window.location.pathname, ['auTracker']);
    });
  },
  prefetchLegacySite: () => ({
    type: PRE_FETCH,
    promise: fetch(config.prefetchPath, { method: 'GET' })
      .then(res => res.json())
      .then(paths => {
        paths.forEach(p => {
          const link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = p;
          document.head.appendChild(link);
        });
      }),
  }),
  setIsMobile: (active = true) => ({
    type: SET_IS_MOBILE,
    active,
  }),
  countBodyScrollLocking: (isLocked) => ({
    type: COUNT_BODY_SCROLL_LOCKING,
    isLocked,
  }),
  getPartnerConfig: (referenceId) => ({
    type: GET_PARTNER_CONFIG,
    affid: referenceId,
    promise: api.get(`/affiliate/config/${referenceId}`),
  }),
  toggleTripPreferenceModal: (isOpened) => ({
    type: isOpened ? OPEN_TRIP_PREFERENCE_MODAL : CLOSE_TRIP_PREFERENCE_MODAL,
  }),
  logTripPreference: (data) => ({
    type: LOG_TRIP_PREFERENCE,
    data,
  }),
  logOnSeenTripPreferencePopup: (data) => ({
    type: LOG_ON_SEEN_TRIP_PREFERENCE_POPUP,
    data,
  }),
  logCloseCountrySelector: () => ({
    type: LOG_CLOSE_COUNTRY_SELECTOR,
  }),
  logCloseTripPreference: (step) => ({
    type: LOG_CLOSE_TRIP_PREFERENCE,
    step,
  })
};

export default reducer;
